import React from 'react';
import './Footer.css';

function Footer() {
        return (
            <div className='footer'>
                Publisher: Stifung Ethereum (“The Ethereum Foundation”)

Collective Work: Summer of Protocols, 2023

Licensed Work: Each individual Article included within the Collective Work

Licensor: Each individual Author of each respective Article included within the Collective Work, as denoted within the Collective Work.
            </div>
        );
}

export default Footer;